module.exports = __webpack_public_path__ + "img/notLegislated.eb3f5750.svg";